import { CanvasType } from '@meitu/saas-editor-core/es/version-types';
import { useTemplateModel } from '@/store/models/template-model';
import { checkImageEditor } from '@/utils/common';

const useDisplayAiExtend = () => {
    const canvasType = useTemplateModel((state) => state.canvasType);
    const isImageEditor = checkImageEditor();

    return !isImageEditor && (canvasType === CanvasType.SINGLE || canvasType === CanvasType.NORMAL);
};

export default useDisplayAiExtend;
